// import React, { useState, useEffect } from "react";
// import { format } from "date-fns";

// const BookingHistoryTable = ({ data,onSelectParcel, selectedParcel }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   // Format date from API response
//   const formatDate = (dateString) => {
//     try {
//       return format(new Date(dateString), "dd/MM/yyyy");
//     } catch {
//       return "N/A";
//     }
//   };

//   // Filter data based on search term
//   const filteredData = data?.filter((item) => {
//     if (!searchTerm) return true;
//     return Object.values(item).some(
//       (value) =>
//         value &&
//         value.toString().toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }) || [];

//   // Pagination logic
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   // Handle page change
//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };
// const handleRowClick = (item) => {
//   if (onSelectParcel) {
//     onSelectParcel(selectedParcel === item.parcelNo ? null : item);
//   }
// };

//   return (
//     <div className="bg-white rounded-lg shadow-md p-4">
//       {/* Search Input */}
//       <div className="mb-4">
//         <input
//           type="text"
//           placeholder="Search bookings..."
//           className="w-full p-2 border border-gray-300 rounded-md"
//           value={searchTerm}
//           onChange={(e) => {
//             setSearchTerm(e.target.value);
//             setCurrentPage(1); // Reset to first page on new search
//           }}
//         />
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Parcel No
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Date
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Sender
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Receiver
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Route
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Cargo Type
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Total Amount
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Payment Status
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {paginatedData.length > 0 ? (
//               paginatedData.map((item, index) => (
                
//                 <tr 
//                     key={index} 
//                     onClick={() => handleRowClick(item)}
//                     className={`
//                       ${index % 2 === 0 ? "bg-white" : "bg-gray-50"}
//                       ${selectedParcel === item.parcelNo ? "ring-2 ring-orange-500" : ""}
//                       cursor-pointer hover:bg-gray-100 transition-colors
//                     `}
//                   >
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                     {item.parcelNo || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {formatDate(item.parcelCreationDate)}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <div className="flex flex-col">
//                       <span className="font-medium">{item.senderName || "N/A"}</span>
//                       <span className="text-gray-400 text-xs">{item.senderEmail || ""}</span>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <div className="flex flex-col">
//                       <span className="font-medium">{item.receiverName || "N/A"}</span>
//                       <span className="text-gray-400 text-xs">{item.receiverEmail || ""}</span>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.routeName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.cargoTypeName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.symbol || ""} {item.subTotal || "0"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
//                       ${item.statusName === "Pending" ? "bg-yellow-100 text-yellow-800" : 
//                         item.statusName === "Shipped" ? "bg-blue-100 text-blue-800" : 
//                         "bg-green-100 text-green-800"}`}>
//                       {item.statusName || "N/A"}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="px-6 py-4 text-center text-sm text-gray-500">
//                   No booking history found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="flex justify-between items-center mt-4">
//           <button
//             onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
//             disabled={currentPage === 1}
//             className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//           >
//             Previous
//           </button>
//           <div className="flex space-x-2">
//             {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//               <button
//                 key={page}
//                 onClick={() => handlePageChange(page)}
//                 className={`px-4 py-2 border rounded-md text-sm font-medium 
//                   ${currentPage === page 
//                     ? "bg-orange-500 text-white border-orange-500" 
//                     : "border-gray-300 text-gray-700 bg-white hover:bg-gray-50"}`}
//               >
//                 {page}
//               </button>
//             ))}
//           </div>
//           <button
//             onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BookingHistoryTable;



// import React, { useState, useEffect } from "react";
// import { format } from "date-fns";
// import { FiFileText } from "react-icons/fi";
// import axios from "axios";

// const BookingHistoryTable = ({ data, onSelectParcel, selectedParcel }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showReportModal, setShowReportModal] = useState(false);
//   const [reportData, setReportData] = useState(null);
//   const [loadingReport, setLoadingReport] = useState(false);
//   const [currentParcelNo, setCurrentParcelNo] = useState(null);
  
//   const itemsPerPage = 10;
//   const backendUrl = process.env.REACT_APP_API_URL;

//   console.log(data)
//   // Format date from API response
//   const formatDate = (dateString) => {
//     try {
//       return format(new Date(dateString), "dd/MM/yyyy");
//     } catch {
//       return "N/A";
//     }
//   };

//   // Filter data based on search term
//   const filteredData = data?.filter((item) => {
//     if (!searchTerm) return true;
//     return Object.values(item).some(
//       (value) =>
//         value &&
//         value.toString().toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }) || [];

//   // Pagination logic
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   // Handle page change
//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handleRowClick = (item) => {
//     if (onSelectParcel) {
//       onSelectParcel(selectedParcel === item.parcelNo ? null : item);
//     }
//   };

//   // Fetch parcel report details
//   const fetchParcelReportDetails = (parcelNo) => {
//     setCurrentParcelNo(parcelNo);
//     setLoadingReport(true);
    
//     axios
//       .get(`${backendUrl}ParcelDetails/GetParcelCostDetails?parcelNo=${parcelNo}`)
//       .then((res) => {
//         setReportData(res.data);
//         setShowReportModal(true);
//       })
//       .catch((error) => {
//         console.error("Error fetching parcel report details:", error.message);
//         // Optional: show toast or alert here
//       })
//       .finally(() => {
//         setLoadingReport(false);
//       });
//   };

//   return (
//     <div className="bg-white rounded-lg shadow-md p-4">
//       {/* Search Input */}
//       <div className="mb-4">
//         <input
//           type="text"
//           placeholder="Search bookings..."
//           className="w-full p-2 border border-gray-300 rounded-md"
//           value={searchTerm}
//           onChange={(e) => {
//             setSearchTerm(e.target.value);
//             setCurrentPage(1); // Reset to first page on new search
//           }}
//         />
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Parcel No
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Date
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Sender
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Receiver
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Route
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Cargo Type
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Total Amount
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Payment Status
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {paginatedData.length > 0 ? (
//               paginatedData.map((item, index) => (
//                 <tr 
//                   key={index} 
//                   onClick={() => handleRowClick(item)}
//                   className={`
//                     ${index % 2 === 0 ? "bg-white" : "bg-gray-50"}
//                     ${selectedParcel === item.parcelNo ? "ring-2 ring-orange-500" : ""}
//                     cursor-pointer hover:bg-gray-100 transition-colors
//                   `}
//                 >
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                     {item.parcelNo || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {formatDate(item.parcelCreationDate)}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <div className="flex flex-col">
//                       <span className="font-medium">{item.senderName || "N/A"}</span>
//                       <span className="text-gray-400 text-xs">{item.senderEmail || ""}</span>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <div className="flex flex-col">
//                       <span className="font-medium">{item.receiverName || "N/A"}</span>
//                       <span className="text-gray-400 text-xs">{item.receiverEmail || ""}</span>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.routeName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.cargoTypeName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.symbol || ""} {item.subTotal || "0"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
//                       ${item.statusName === "Pending" ? "bg-yellow-100 text-yellow-800" : 
//                         item.statusName === "Shipped" ? "bg-blue-100 text-blue-800" : 
//                         "bg-green-100 text-green-800"}`}>
//                       {item.statusName || "N/A"}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation(); // Prevent row click from triggering
//                         fetchParcelReportDetails(item.parcelNo);
//                       }}
//                       disabled={loadingReport && currentParcelNo === item.parcelNo}
//                       className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
//                     >
//                       <FiFileText className="inline" />
//                       {loadingReport && currentParcelNo === item.parcelNo ? "Loading..." : "Report"}
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="9" className="px-6 py-4 text-center text-sm text-gray-500">
//                   No booking history found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="flex justify-between items-center mt-4">
//           <button
//             onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
//             disabled={currentPage === 1}
//             className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//           >
//             Previous
//           </button>
//           <div className="flex space-x-2">
//             {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//               <button
//                 key={page}
//                 onClick={() => handlePageChange(page)}
//                 className={`px-4 py-2 border rounded-md text-sm font-medium 
//                   ${currentPage === page 
//                     ? "bg-orange-500 text-white border-orange-500" 
//                     : "border-gray-300 text-gray-700 bg-white hover:bg-gray-50"}`}
//               >
//                 {page}
//               </button>
//             ))}
//           </div>
//           <button
//             onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* Report Modal */}
//       {showReportModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-2xl font-bold">Parcel Report Details</h2>
//               <button
//                 onClick={() => setShowReportModal(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M6 18L18 6M6 6l12 12"
//                   />
//                 </svg>
//               </button>
//             </div>

//             {loadingReport ? (
//               <div className="flex justify-center items-center h-32">
//                 <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//               </div>
//             ) : (
//               <>
//                 <div className="mb-6">
//                   <h3 className="text-lg font-semibold mb-2">
//                     Parcel Number: {currentParcelNo}
//                   </h3>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
//                   <div className="bg-gray-50 p-4 rounded-lg">
//                     <h4 className="font-medium text-gray-700 mb-2">Sender Information</h4>
//                     <div className="space-y-2">
//                       <div className="flex justify-between">
//                         <span>Name:</span>
//                         <span>{reportData?.senderName || "N/A"}</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Phone:</span>
//                         <span>{reportData?.senderPhone || "N/A"}</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Address:</span>
//                         <span>{reportData?.senderAddress || "N/A"}</span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="bg-gray-50 p-4 rounded-lg">
//                     <h4 className="font-medium text-gray-700 mb-2">Receiver Information</h4>
//                     <div className="space-y-2">
//                       <div className="flex justify-between">
//                         <span>Name:</span>
//                         <span>{reportData?.receiverName || "N/A"}</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Phone:</span>
//                         <span>{reportData?.receiverPhone || "N/A"}</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Address:</span>
//                         <span>{reportData?.receiverAddress || "N/A"}</span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="bg-gray-50 p-4 rounded-lg">
//                     <h4 className="font-medium text-gray-700 mb-2">Parcel Details</h4>
//                     <div className="space-y-2">
//                       <div className="flex justify-between">
//                         <span>Weight:</span>
//                         <span>{reportData?.weight || "N/A"} kg</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Dimensions:</span>
//                         <span>{reportData?.dimensions || "N/A"}</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Cargo Type:</span>
//                         <span>{reportData?.cargoTypeName || "N/A"}</span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="bg-gray-50 p-4 rounded-lg">
//                     <h4 className="font-medium text-gray-700 mb-2">Shipping Information</h4>
//                     <div className="space-y-2">
//                       <div className="flex justify-between">
//                         <span>Route:</span>
//                         <span>{reportData?.routeName || "N/A"}</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Status:</span>
//                         <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
//                           ${reportData?.statusName === "Pending" ? "bg-yellow-100 text-yellow-800" : 
//                             reportData?.statusName === "Shipped" ? "bg-blue-100 text-blue-800" : 
//                             "bg-green-100 text-green-800"}`}>
//                           {reportData?.statusName || "N/A"}
//                         </span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Created Date:</span>
//                         <span>{formatDate(reportData?.parcelCreationDate) || "N/A"}</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="bg-blue-50 p-4 rounded-lg">
//                   <div className="flex justify-between items-center">
//                     <h4 className="font-bold text-lg">Total Amount:</h4>
//                     <span className="text-xl font-bold">
//                       {reportData?.symbol || ""} {reportData?.subTotal || "0"}
//                     </span>
//                   </div>
//                 </div>

//                 <div className="mt-4 bg-gray-50 p-4 rounded-lg">
//                   <h4 className="font-medium text-gray-700 mb-2">Additional Notes</h4>
//                   <p className="text-gray-600">
//                     {reportData?.notes || "No additional notes available."}
//                   </p>
//                 </div>
//               </>
//             )}

//             <div className="mt-6 flex justify-end">
//               <button
//                 onClick={() => setShowReportModal(false)}
//                 className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
//               >
//                 Close
//               </button>
//               {/* <button
//                 onClick={() => {
                 
//                   window.print();
//                 }}
//                 className="ml-2 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
//               >
//                 Print Report
//               </button> */}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BookingHistoryTable;















// import React, { useState, useRef } from "react";
// import { format } from "date-fns";
// import { FiFileText, FiDownload } from "react-icons/fi";
// import axios from "axios";
// import { usePDF } from 'react-to-pdf';

// const BookingHistoryTable = ({ data, onSelectParcel, selectedParcel }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showReportModal, setShowReportModal] = useState(false);
//   const [parcelData, setParcelData] = useState(null);
//   const [costData, setCostData] = useState(null);
//   const [loadingReport, setLoadingReport] = useState(false);
//   const backendUrl = process.env.REACT_APP_API_URL;
  
//   const itemsPerPage = 10;
//   const { toPDF, targetRef } = usePDF({ 
//     filename: `parcel-receipt-${parcelData?.parcelNo || 'receipt'}.pdf`,
//     page: { margin: 10 }
//   });

//   const formatDate = (dateString) => {
//     try {
//       return format(new Date(dateString), "dd/MM/yyyy");
//     } catch {
//       return "N/A";
//     }
//   };

//   const filteredData = data?.filter((item) => {
//     if (!searchTerm) return true;
//     return Object.values(item).some(
//       (value) =>
//         value &&
//         value.toString().toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }) || [];

//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handleRowClick = (item) => {
//     if (onSelectParcel) {
//       onSelectParcel(selectedParcel === item.parcelNo ? null : item);
//     }
//   };
// console.log(parcelData)
//   const fetchParcelReportDetails = (parcel) => {
//     setParcelData(parcel);
//     setLoadingReport(true);
    
//     axios
//       .get(`${backendUrl}ParcelDetails/GetParcelCostDetails?parcelNo=${parcel.parcelNo}`)
//       .then((res) => {
//         setCostData(res.data);
//         setShowReportModal(true);
//       })
//       .catch((error) => {
//         console.error("Error fetching parcel report details:", error.message);
//         // Optional: show toast or alert here
//       })
//       .finally(() => {
//         setLoadingReport(false);
//       });
//   };
// const statusColors = {
//     pending: {
//       bg: 'bg-yellow-100', // was oklch()
//       text: 'text-yellow-800'
//     },
//     completed: {
//       bg: 'bg-green-100', // was oklch()
//       text: 'text-green-800'
//     }
//   };
  

//   const generateReceipt = () => {
//     if (!parcelData) return null;

//     const totalAmount = (costData?.subTotal || 0) + (costData?.vaT_TaxAmount || 0);

//     return (
//      <div ref={targetRef} className="p-4" style={{
//         width: '794px',
//         fontFamily: 'Arial, sans-serif',
//         fontSize: '14px',
//         color: '#333333' // Standard hex instead of oklch()
//       }}>
//         {/* Header with standard colors */}
//         <div className="text-center mb-4">
//           {/* <h1 className="text-2xl font-bold" style={{ color: '#222' }}>Parcel Receipt</h1> */}
//           <h1 className="text-2xl font-bold" style={{ color: '#222222' }}>
//             Parcel Receipt
//           </h1>
//           <div className="flex justify-between text-sm mt-2" style={{ color: 'black' }}>
//             <p>Date: {format(new Date(), "dd/MM/yyyy HH:mm")}</p>
//             <p>Receipt No: {parcelData.parcelNo}</p>
//           </div>
//         </div>

//         {/* Sender/Receiver Info */}
//         <div className="grid grid-cols-2 gap-4 mb-4">
//           <div className="border p-2">
//             <h3 className="font-bold border-b pb-1">Sender</h3>
//             <p className="mt-1"><span className="font-semibold">Name:</span> {parcelData.senderName || "N/A"}</p>
//             <p><span className="font-semibold">Email:</span> {parcelData.senderEmail || "N/A"}</p>
//           </div>
//           <div className="border p-2">
//             <h3 className="font-bold border-b pb-1">Receiver</h3>
//             <p className="mt-1"><span className="font-semibold">Name:</span> {parcelData.receiverName || "N/A"}</p>
//             <p><span className="font-semibold">Email:</span> {parcelData.receiverEmail || "N/A"}</p>
//           </div>
//         </div>

//         {/* Parcel Details */}
//         <div className="border p-2 mb-4">
//           <h3 className="font-bold border-b pb-1">Parcel Information</h3>
//           <div className="grid grid-cols-3 gap-2 mt-1">
//             <p><span className="font-semibold">Route:</span> {parcelData.routeName || "N/A"}</p>
//             <p><span className="font-semibold">Cargo Type:</span> {parcelData.cargoTypeName || "N/A"}</p>
//             <p><span className="font-semibold">Status:</span> {parcelData.statusName || "N/A"}</p>
//             <p><span className="font-semibold">Dimension:</span> {parcelData.dimensionName || "N/A"}</p>
//             <p><span className="font-semibold">Weight:</span> {parcelData.weightDescription || "N/A"}</p>
//             <p><span className="font-semibold">Created:</span> {formatDate(parcelData.parcelCreationDate)}</p>
//           </div>
//         </div>

//         {/* Cost Breakdown */}
//         <div className="border p-2 mb-4">
//           <h3 className="font-bold border-b pb-1">Payment Details</h3>
//           <table className="w-full mt-1">
//             <tbody>
//               {costData?.weightCost !== undefined && (
//                 <tr>
//                   <td className="font-semibold">Weight Cost:</td>
//                   <td className="text-right">{parcelData.symbol} {costData.weightCost || 0}</td>
//                 </tr>
//               )}
//               {costData?.dimensionCost !== undefined && (
//                 <tr>
//                   <td className="font-semibold">Dimension Cost:</td>
//                   <td className="text-right">{parcelData.symbol} {costData.dimensionCost || 0}</td>
//                 </tr>
//               )}
//               {costData?.routeCost !== undefined && (
//                 <tr>
//                   <td className="font-semibold">Route Cost:</td>
//                   <td className="text-right">{parcelData.symbol} {costData.routeCost || 0}</td>
//                 </tr>
//               )}
//               {costData?.vaT_TaxAmount !== undefined && (
//                 <tr>
//                   <td className="font-semibold">VAT Tax:</td>
//                   <td className="text-right">{parcelData.symbol} {costData.vaT_TaxAmount || 0}</td>
//                 </tr>
//               )}
//               <tr className="border-t">
//                 <td className="font-bold">Subtotal:</td>
//                 <td className="text-right font-bold">{parcelData.symbol} {costData?.subTotal || parcelData.subTotal || 0}</td>
//               </tr>
//               <tr className="border-t-2">
//                 <td className="font-bold text-lg">Total Amount:</td>
//                 <td className="text-right font-bold text-lg">{parcelData.symbol} {totalAmount}</td>
//               </tr>
//               <tr>
//                 <td className="font-bold">Payment Status:</td>
//                 <td className="text-right">
//                   <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
//                     ${parcelData.statusName === "Pending" ? "bg-yellow-100 text-yellow-800" : 
//                       "bg-green-100 text-green-800"}`}>
//                     {parcelData.statusName || "N/A"}
//                   </span>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//         {/* Footer */}
//         <div className="text-center text-xs mt-6">
//           <p>Thank you for using our service</p>
//           <p className="mt-1">For any queries, please contact our customer support</p>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="bg-white rounded-lg shadow-md p-4">
//       {/* Search Input */}
//       <div className="mb-4">
//         <input
//           type="text"
//           placeholder="Search bookings..."
//           className="w-full p-2 border border-gray-300 rounded-md"
//           value={searchTerm}
//           onChange={(e) => {
//             setSearchTerm(e.target.value);
//             setCurrentPage(1);
//           }}
//         />
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Parcel No</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sender</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Receiver</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Route</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Receipt</th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {paginatedData.length > 0 ? (
//               paginatedData.map((item, index) => (
//                 <tr 
//                   key={index} 
//                   onClick={() => handleRowClick(item)}
//                   className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"} ${
//                     selectedParcel === item.parcelNo ? "ring-2 ring-orange-500" : ""
//                   } cursor-pointer hover:bg-gray-100`}
//                 >
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                     {item.parcelNo || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {formatDate(item.parcelCreationDate)}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.senderName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.receiverName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {item.routeName || "N/A"}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     {formatCurrency(item.subTotal || 0, item.symbol || "GBP")}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
//                       ${item.statusName === "Pending" ? "bg-yellow-100 text-yellow-800" : 
//                         "bg-green-100 text-green-800"}`}>
//                       {item.statusName || "N/A"}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         fetchParcelReportDetails(item);
//                       }}
//                       disabled={loadingReport && parcelData?.parcelNo === item.parcelNo}
//                       className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
//                     >
//                       <FiFileText className="inline" />
//                       {loadingReport && parcelData?.parcelNo === item.parcelNo ? "Loading..." : "Download"}
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="px-6 py-4 text-center text-sm text-gray-500">
//                   No booking history found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="flex justify-between items-center mt-4">
//           <button
//             onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
//             disabled={currentPage === 1}
//             className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//           >
//             Previous
//           </button>
//           <div className="flex space-x-2">
//             {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//               <button
//                 key={page}
//                 onClick={() => handlePageChange(page)}
//                 className={`px-4 py-2 border rounded-md text-sm font-medium ${
//                   currentPage === page 
//                     ? "bg-orange-500 text-white border-orange-500" 
//                     : "border-gray-300 text-gray-700 bg-white hover:bg-gray-50"
//                 }`}
//               >
//                 {page}
//               </button>
//             ))}
//           </div>
//           <button
//             onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* Receipt Modal */}
//       {showReportModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-2xl font-bold">Parcel Receipt</h2>
//               <div className="flex gap-2">
//                 <button
//                   onClick={() => toPDF()}
//                   className="flex items-center gap-1 px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
//                 >
//                   <FiDownload /> Download PDF
//                 </button>
//                 <button
//                   onClick={() => setShowReportModal(false)}
//                   className="text-gray-500 hover:text-gray-700"
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-6 w-6"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>
//             </div>

//             {loadingReport ? (
//               <div className="flex justify-center items-center h-32">
//                 <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//               </div>
//             ) : (
//               generateReceipt()
//             )}

//             <div className="mt-6 flex justify-end">
//               <button
//                 onClick={() => setShowReportModal(false)}
//                 className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition-colors"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BookingHistoryTable;








import React, { useState, useRef } from "react";
import { format } from "date-fns";
import { FiFileText, FiDownload } from "react-icons/fi";
import axios from "axios";
import { usePDF } from 'react-to-pdf';
import { formatCurrency } from "../../../../utils/formatCurrency";
import { Icon } from "@iconify/react";

const REFUND_WHATSAPP_CONTACTS = [
  { label: "01723925785", waId: "8801723925785" },
  { label: "+44 7775 318440", waId: "447775318440" },
];

const buildRefundWhatsAppUrl = (waId, parcel) => {
  const message = encodeURIComponent(
    `Hello, I would like to request a refund for parcel #${parcel?.parcelNo || "N/A"}.`,
  );
  return `https://wa.me/${waId}?text=${message}`;
};

const BookingHistoryTable = ({ data, onSelectParcel, selectedParcel }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [refundParcel, setRefundParcel] = useState(null);
  const [parcelData, setParcelData] = useState(null);
  const [costData, setCostData] = useState(null);
  const [loadingReport, setLoadingReport] = useState(false);
  const backendUrl = process.env.REACT_APP_API_URL;
  
  const itemsPerPage = 10;
  const { toPDF, targetRef } = usePDF({ 
    filename: `parcel-receipt-${parcelData?.parcelNo || 'receipt'}.pdf`,
    page: { margin: 10 }
  });

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), "dd/MM/yyyy");
    } catch {
      return "N/A";
    }
  };

  const filteredData = data?.filter((item) => {
    if (!searchTerm) return true;
    return Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );
  }) || [];

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowClick = (item) => {
    if (onSelectParcel) {
      onSelectParcel(selectedParcel === item.parcelNo ? null : item);
    }
  };

  const openRefundModal = (e, parcel) => {
    e.stopPropagation();
    setRefundParcel(parcel);
    setShowRefundModal(true);
  };

  const closeRefundModal = () => {
    setShowRefundModal(false);
    setRefundParcel(null);
  };

  const fetchParcelReportDetails = (parcel) => {
    setParcelData(parcel);
    setLoadingReport(true);
    
    axios
      .get(`${backendUrl}ParcelDetails/GetParcelCostDetails?parcelNo=${parcel.parcelNo}`)
      .then((res) => {
        setCostData(res.data);
        setShowReportModal(true);
      })
      .catch((error) => {
        console.error("Error fetching parcel report details:", error.message);
      })
      .finally(() => {
        setLoadingReport(false);
      });
  };

  const generateReceipt = () => {
    if (!parcelData) return null;

    const totalAmount = (costData?.subTotal || 0) + (costData?.vaT_TaxAmount || 0);

    return (
      <div ref={targetRef} className="p-4" style={{ 
        width: '794px', 
        fontFamily: 'Arial, sans-serif',
        fontSize: '14px',
        color: '#333333',
        backgroundColor: '#ffffff'
      }}>
        {/* Header */}
        <div className="text-center mb-4">
          <h1 className="text-2xl font-bold" style={{ color: '#222222' }}>Parcel Receipt</h1>
          <div className="flex justify-between text-sm mt-2" style={{ color: '#555555' }}>
            <p>Date: {format(new Date(), "dd/MM/yyyy HH:mm")}</p>
            <p>Parcel No: #{parcelData.parcelNo}</p>
          </div>
        </div>

        {/* Sender/Receiver Info */}
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="border p-2" style={{ borderColor: '#dddddd' }}>
            <h3 className="font-bold border-b pb-1" style={{ borderColor: '#eeeeee' }}>Sender</h3>
            <p className="mt-1"><span className="font-semibold">Name:</span> {parcelData.senderName || "N/A"}</p>
            <p><span className="font-semibold">Email:</span> {parcelData.senderEmail || "N/A"}</p>
          </div>
          <div className="border p-2" style={{ borderColor: '#dddddd' }}>
            <h3 className="font-bold border-b pb-1" style={{ borderColor: '#eeeeee' }}>Receiver</h3>
            <p className="mt-1"><span className="font-semibold">Name:</span> {parcelData.receiverName || "N/A"}</p>
            <p><span className="font-semibold">Email:</span> {parcelData.receiverEmail || "N/A"}</p>
          </div>
        </div>

        {/* Parcel Details */}
        <div className="border p-2 mb-4" style={{ borderColor: '#dddddd' }}>
          <h3 className="font-bold border-b pb-1" style={{ borderColor: '#eeeeee' }}>Parcel Information</h3>
          <div className="grid grid-cols-3 gap-2 mt-1">
            <p><span className="font-semibold">Route:</span> {parcelData.routeName || "N/A"}</p>
            <p><span className="font-semibold">Cargo Type:</span> {parcelData.cargoTypeName || "N/A"}</p>
            <p><span className="font-semibold">Status:</span> {parcelData.currentParcelStatusName || "Pending"}</p>
            <p><span className="font-semibold">Dimension:</span> {parcelData.dimensionName || "N/A"}</p>
            <p><span className="font-semibold">Weight:</span> {parcelData.weightDescription || "N/A"}</p>
            <p><span className="font-semibold">Created:</span> {formatDate(parcelData.parcelCreationDate)}</p>
          </div>
        </div>

        {/* Cost Breakdown */}
        <div className="border p-2 mb-4" style={{ borderColor: '#dddddd' }}>
          <h3 className="font-bold border-b pb-1" style={{ borderColor: '#eeeeee' }}>Payment Details</h3>
          <table className="w-full mt-1">
            <tbody>
              {/* {costData?.weightCost !== undefined && (
                <tr>
                  <td className="font-semibold">Weight Cost:</td>
                  <td className="text-right">{parcelData.symbol} {costData.weightCost || 0}</td>
                </tr>
              )}
              {costData?.dimensionCost !== undefined && (
                <tr>
                  <td className="font-semibold">Dimension Cost:</td>
                  <td className="text-right">{parcelData.symbol} {costData.dimensionCost || 0}</td>
                </tr>
              )}
              {costData?.routeCost !== undefined && (
                <tr>
                  <td className="font-semibold">Route Cost:</td>
                  <td className="text-right">{parcelData.symbol} {costData.routeCost || 0}</td>
                </tr>
              )}
              {costData?.vaT_TaxAmount !== undefined && (
                <tr>
                  <td className="font-semibold" style={{marginTop:"2px"}}>VAT Tax:</td>
                  <td className="text-right">{parcelData.symbol} {costData.vaT_TaxAmount || 0}</td>
                </tr>
              )}
              
              <tr className="border-t" style={{ borderColor: '#eeeeee'}}>
                <td className="font-bold">Subtotal:</td>
                <td className="text-right font-bold">{parcelData.symbol} {costData?.subTotal || parcelData.subTotal || 0}</td>
              </tr> */}
              <tr className="border-t-2" style={{ borderColor: '#dddddd' ,marginTop:" 1px" }}>
                <td className="font-bold text-lg">Total Amount:</td>
                <td className="text-right font-bold text-lg">
                  {formatCurrency(totalAmount, parcelData.symbol || "GBP")}
                </td>
              </tr>
              <tr>
                <td className="font-bold">Payment Status:</td>
                <td className="text-right">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full `}>
                    {parcelData.statusName || "N/A"}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="text-center text-xs mt-6" style={{ color: '#777777' }}>
          <p>Thank you for using our service</p>
          <p className="mt-1">For any queries, please contact our customer support</p>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-4">
      {/* Search Input */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search bookings..."
          className="w-full p-2 border border-gray-300 rounded-md"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Parcel No</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Date</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Sender</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Receiver</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Route</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Amount</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <tr 
                  key={index} 
                  onClick={() => handleRowClick(item)}
                  className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"} ${
                    selectedParcel === item.parcelNo ? "ring-2 ring-blue-500" : ""
                  } cursor-pointer hover:bg-gray-100`}
                >
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {item.parcelNo || "N/A"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {formatDate(item.parcelCreationDate)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {item.senderName || "N/A"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {item.receiverName || "N/A"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {item.routeName || "N/A"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {formatCurrency(
                      item.subTotal ||
                        item.orderPayableAmount ||
                        item.totalAmount ||
                        0,
                      item.symbol || "GBP",
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                      ${item.statusName === "Pending" 
                        ? "bg-amber-100 text-amber-800" 
                        : "bg-emerald-100 text-emerald-800"}`}>
                      {item.statusName || "N/A"}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          fetchParcelReportDetails(item);
                        }}
                        disabled={
                          loadingReport && parcelData?.parcelNo === item.parcelNo
                        }
                        className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
                      >
                        <FiFileText className="inline" />
                        {loadingReport && parcelData?.parcelNo === item.parcelNo
                          ? "Loading..."
                          : "Report"}
                      </button>
                      <button
                        type="button"
                        onClick={(e) => openRefundModal(e, item)}
                        className="text-green-700 hover:text-green-900 flex items-center gap-1 font-medium"
                      >
                        <Icon icon="logos:whatsapp-icon" width={16} />
                        Refund
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="px-6 py-4 text-center text-sm text-gray-700">
                  No booking history found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-between items-center mt-4">
          <button
            onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
          >
            Previous
          </button>
          <div className="flex space-x-2">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={`px-4 py-2 border rounded-md text-sm font-medium ${
                                   currentPage === page
                    ? "bg-blue-500 text-white border-blue-500"
                    : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                }`}
              >
                {page}
              </button>
            ))}
          </div>
          <button
            onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}

      {/* Receipt Modal (Optional) */}
      {showRefundModal && refundParcel && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center px-4">
          <div
            className="bg-white max-w-md w-full rounded-lg shadow-lg p-6 relative"
            role="dialog"
            aria-modal="true"
            aria-labelledby="refund-modal-title"
          >
            <button
              type="button"
              onClick={closeRefundModal}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl font-bold"
              aria-label="Close refund dialog"
            >
              &times;
            </button>
            <div className="flex items-center gap-3 mb-4">
              <Icon icon="logos:whatsapp-icon" width={32} />
              <h2
                id="refund-modal-title"
                className="text-xl font-bold text-gray-900"
              >
                Request a refund
              </h2>
            </div>
            <p className="text-gray-600 mb-2">
              Refunds are handled by our support team on WhatsApp.
            </p>
            <p className="text-gray-600 mb-4">
              Please contact us on WhatsApp with parcel{" "}
              <span className="font-semibold text-gray-900">
                #{refundParcel.parcelNo}
              </span>{" "}
              and we will assist you as soon as possible.
            </p>
            <div className="flex flex-col gap-2 mb-4">
              {REFUND_WHATSAPP_CONTACTS.map((contact) => (
                <a
                  key={contact.waId}
                  href={buildRefundWhatsAppUrl(contact.waId, refundParcel)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-green-600 text-white font-semibold hover:bg-green-700"
                >
                  <Icon icon="logos:whatsapp-icon" width={18} />
                  Chat on {contact.label}
                </a>
              ))}
            </div>
            <div className="flex justify-end">
              <button
                type="button"
                onClick={closeRefundModal}
                className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showReportModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center px-4">
          <div className="bg-white max-w-4xl w-full max-h-[90vh] overflow-y-auto rounded-lg shadow-lg p-4 relative">
            <button
              onClick={() => setShowReportModal(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold"
            >
              &times;
            </button>
            {generateReceipt()}
            <div className="flex justify-end mt-4">
              <button
                onClick={toPDF}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 flex items-center gap-2"
              >
                <FiDownload />
                Download PDF
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingHistoryTable;
